import styled from 'styled-components';
import { DokType } from '../provider/Typo3Provider/types';
import { media } from '../theme/base/mixins';
import { ImportantText } from './Text';
import { Title } from './Title';
import { Column } from './Grid';

interface MainProps {
  doktype: DokType;
}

export const MainContentContainer = styled.div<MainProps>`
  ${Column} {
    &[data-small='12'] {
      margin-bottom: ${(props) =>
        props.theme.grid.columnGap}px;

      ${media.medium`
        margin-bottom: 0;
      `};
    }
  }

  ${Title.ContentTitle}, ${ImportantText} {
    color: ${(props) =>
      props.doktype === 'magazine' ? props.theme.colors.secondary : 'inherit'};
  }
`;
